import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
import axios from 'axios';
import { api_url } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'
// Bütün customerləri gətir
export const get_customers = createAsyncThunk(
    'customer/get_customers',
    async ({ page, searchValue, parPage }, { rejectWithValue, fulfillWithValue, getState }) => {
            // const token = getState().auth.token
            // const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            const { data } = await axios.get(`${api_url}/api/admin/customers`, {
                withCredentials: true,
                params: {
                    page: page,
                    searchValue,
                    limit: parPage
                }
            });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Customer-i ban et
export const ban_customer = createAsyncThunk(
    'customer/ban_customer',
    async ({ customerId, reason }, { rejectWithValue, fulfillWithValue, getState }) => {
                // const token = getState().auth.token
                // const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            const { data } = await api.put(`/admin/customers/${customerId}/ban`, {
                reason
            }, {withCredentials: true});
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Customer-in ban-ını aç
export const unban_customer = createAsyncThunk(
    'customer/unban_customer',
    async (customerId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            const { data } = await api.put(`/admin/customers/${customerId}/unban`, null, {withCredentials: true});
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Customer-i sil
export const delete_customer = createAsyncThunk(
    'customer/delete_customer',
    async (customerId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            const { data } = await api.delete(`/admin/customers/${customerId}`, {withCredentials: true});
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Tək customer-i gətir
export const get_customer = createAsyncThunk(
    'customer/get_customer',
    async (customerId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            const { data } = await axios.get(`${api_url}/api/admin/customers/${customerId}`, {withCredentials: true});
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const get_banned_customers = createAsyncThunk(
    'customer/get_banned_customers',
    async ({ page, searchValue, parPage }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token
        // const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            const { data } = await axios.get(`${api_url}/api/admin/customers/banned/list`, {
                withCredentials: true,
                params: {
                    page: page,
                    searchValue,
                    limit: parPage
                }
            });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const customerReducer = createSlice({
    name: 'customer',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        customers: [],
        totalCustomers: 0,
        customer: null
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        }
    },
    extraReducers: (builder) => {
        builder
            // Get customers
            .addCase(get_customers.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_customers.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Error loading customers';
            })
            .addCase(get_customers.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.customers = payload.customers || payload.data || [];
                state.totalCustomers = paginationTotal(payload, 'totalCustomers');
            })

            // Ban customer
            .addCase(ban_customer.pending, (state) => {
                state.loader = true;
            })
            .addCase(ban_customer.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Error banning customer';
            })
            .addCase(ban_customer.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
                // Update customer in list
                const index = state.customers.findIndex(c => c._id === payload.customer._id);
                if (index !== -1) {
                    state.customers[index] = payload.customer;
                }
            })

            // Unban customer
            .addCase(unban_customer.pending, (state) => {
                state.loader = true;
            })
            .addCase(unban_customer.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Error unbanning customer';
            })
            .addCase(unban_customer.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
                // Update customer in list
                const index = state.customers.findIndex(c => c._id === payload.customer._id);
                if (index !== -1) {
                    state.customers[index] = payload.customer;
                }
            })

            // Delete customer
            .addCase(delete_customer.pending, (state) => {
                state.loader = true;
            })
            .addCase(delete_customer.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Error deleting customer';
            })
            .addCase(delete_customer.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
            })

            // Get single customer
            .addCase(get_customer.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_customer.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Error loading customer';
            })
            .addCase(get_customer.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.customer = payload.customer;
            })
              .addCase(get_banned_customers.pending, (state) => {
            state.loader = true;
        })
        .addCase(get_banned_customers.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.message || 'Error loading banned customers';
        })
        .addCase(get_banned_customers.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.customers = payload.customers || payload.data || [];
            state.totalCustomers = paginationTotal(payload, 'totalCustomers');
        });
            
            
    }
});

export const { messageClear } = customerReducer.actions;
export default customerReducer.reducer;
